/**
 * ValidationResult enum.
 *
 * @copyright Realeyes OU. All rights reserved.
 */


/**
 * @enum {string}
 */
const ValidationResult = {
    OK: 'OK',
    NO_RESULT: 'NO_RESULT',
    NO_FACE: 'NO_FACE',
    FACE_TOO_FAR: 'FACE_TOO_FAR',
    FACE_OFF_CENTER: 'FACE_OFF_CENTER',
    STILL_IMAGE: 'STILL_IMAGE',
    TOO_DARK: 'TOO_DARK',
    TOO_BRIGHT: 'TOO_BRIGHT',
    FACE_TOO_DARK: 'FACE_TOO_DARK',
    FACE_TOO_BRIGHT: 'FACE_TOO_BRIGHT',
};


export default ValidationResult;
